
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/player-stats",
      function () {
        return require("private-next-pages/[league]/player-stats/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/player-stats"])
      });
    }
  